import api from './apiConfig';

// apiConfig monta gia' `${API_URL}${API_BASE_PATH}`, cioe' /v1, come baseURL:
// i percorsi qui sono relativi a quello, come fa permissionService.
const userAdminService = {
    // Una pagina e non l'elenco intero (B14): `{ righe, totale, pagina, dimensione }`.
    // `stato` e' tutti | attivi | disattivati | senza-account; `q` cerca in nome ed email.
    listUsers: ({ q, stato, pagina, dimensione } = {}) =>
        api
            .get('/users', { params: { q: q || undefined, stato, pagina, dimensione } })
            .then((r) => r.data),
    getUser: (sub) => api.get(`/users/${encodeURIComponent(sub)}`).then((r) => r.data),
    // `replaceRoles` non c'e' piu' (fase F6): PUT /users/{sub}/roles scriveva `user_role`,
    // che il resolver non legge piu' e che F6 ha eliminato. Si assegna con `grant`, che
    // scrive il ruolo insieme al gruppo in cui vale.
    getEffectivePermissions: (sub) =>
        api.get(`/users/${encodeURIComponent(sub)}/effective-permissions`).then((r) => r.data),
    listRoles: () => api.get('/roles').then((r) => r.data),

    // --- Le concessioni: ruolo + gruppo (fase F3 di «il gruppo come ambito») ---
    // `groupId` assente significa «ogni gruppo» (D6), non «nessun gruppo»: e' la forma
    // dell'amministratore globale, e il backend la legge cosi'. Per questo la revoca ha due
    // percorsi e non uno con un segmento vuoto — un segmento assente e uno vuoto sono
    // indistinguibili a chi legge la richiesta in un log.
    listGrants: (sub) => api.get(`/users/${encodeURIComponent(sub)}/grants`).then((r) => r.data),
    grant: (sub, roleId, groupId) =>
        api
            .post(`/users/${encodeURIComponent(sub)}/grants`, { roleId, groupId: groupId || null })
            .then((r) => r.data),
    revokeGrant: (sub, roleId, groupId) =>
        api.delete(
            groupId
                ? `/users/${encodeURIComponent(sub)}/grants/${encodeURIComponent(roleId)}/${encodeURIComponent(groupId)}`
                : `/users/${encodeURIComponent(sub)}/grants/${encodeURIComponent(roleId)}`,
        ),

    // --- Ciclo di vita dell'account (spec «Gestione del ciclo di vita degli utenti», §9) ---
    // La risposta di `createUser` e `resetPassword` contiene la password temporanea: e'
    // l'unica volta che esiste fuori da Keycloak. Non va registrata, ne' rimessa in un log,
    // ne' tenuta in stato piu' a lungo del dialogo che la mostra.
    createUser: (utente) => api.post('/users', utente).then((r) => r.data),
    // Se il realm usa l'email come username: con quell'impostazione lo username inviato
    // verrebbe scartato, quindi il dialogo non lo chiede.
    getCreationSettings: () => api.get('/users/creation-settings').then((r) => r.data),
    resetPassword: (sub) =>
        api.post(`/users/${encodeURIComponent(sub)}/reset-password`).then((r) => r.data),
    disableUser: (sub) => api.post(`/users/${encodeURIComponent(sub)}/disable`),
    enableUser: (sub) => api.post(`/users/${encodeURIComponent(sub)}/enable`),
    deleteUser: (sub) => api.delete(`/users/${encodeURIComponent(sub)}`),

    // Revoca le concessioni di chi e' stato cancellato su Keycloak (le persone del filtro
    // «Senza account»). Risponde `{ accounts, grants }`: quante persone e quante concessioni.
    cleanupDeletedAccounts: () =>
        api.post('/users/deleted-accounts/cleanup').then((r) => r.data),
};

export default userAdminService;
